import React, { useEffect, createElement } from 'react';
import { FarmingtonHeroInfo } from './farmington/FarmingtonHeroInfo';
import { FarmingtonHeroForm } from './farmington/FarmingtonHeroForm';
import { FarmingtonDistance } from './farmington/FarmingtonDistance';
import { FarmingtonWhy } from './farmington/FarmingtonWhy';
import { FarmingtonPrograms } from './farmington/FarmingtonPrograms';
import { FarmingtonScheduleLocation } from './farmington/FarmingtonScheduleLocation';
import { FarmingtonReviews } from './farmington/FarmingtonReviews';
import { FarmingtonFAQHeader } from './farmington/FarmingtonFAQHeader';
import { FarmingtonFAQQuestions } from './farmington/FarmingtonFAQQuestions';
import { FarmingtonLinks } from './farmington/FarmingtonLinks';
import { FarmingtonFinalCTA } from './farmington/FarmingtonFinalCTA';
export function Farmington() {
  useEffect(() => {
    document.title = 'Martial Arts & Taekwondo Near Farmington, MI | Storm';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Storm Taekwondo serves the Farmington community with premium kids, adult, and family martial arts classes. Claim your free one-week trial.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Storm Taekwondo serves the Farmington community with premium kids, adult, and family martial arts classes. Claim your free one-week trial.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-1256">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-1257">
        <div className="absolute inset-0 opacity-20" data-id="element-1258">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-1259" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-1260" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1261">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1262">
            <FarmingtonHeroInfo data-id="element-1263" />
            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-1264">
              <FarmingtonHeroForm data-id="element-1265" />
            </div>
          </div>
        </div>
      </section>

      <FarmingtonDistance data-id="element-1266" />
      <FarmingtonWhy data-id="element-1267" />
      <FarmingtonPrograms data-id="element-1268" />
      <FarmingtonScheduleLocation data-id="element-1269" />
      <FarmingtonReviews data-id="element-1270" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-1271">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1272">
          <FarmingtonFAQHeader data-id="element-1273" />
          <FarmingtonFAQQuestions data-id="element-1274" />
        </div>
      </section>
      <FarmingtonLinks data-id="element-1275" />
      <FarmingtonFinalCTA data-id="element-1276" />
    </div>;
}